<template>
    <b-container class="m-0 p-0">

		<draggable v-model="data.Tags"
				   group="parentTags"
				   v-bind="{handle:'.parent-handle', animation:150}"
				   @input="updateParentSorting">

			<tag-list v-for="(item, index) in data.Tags"
					  :key="'parentTag_' + item.Id"
					  :parent-tag="item"
					  :parent-tag-index="index"
                      :edit-link="editLink"
					  @remove="deleteTagDialog"
					  @change="changeTag"
                      :apiVersion="apiVersion"
			/>

		</draggable>

	</b-container>
</template>

<script>
import dialogService from '@/services/dialog.service'
import TagList from '@/components/admin/tags/TagList'

export default {
    props: {
        data: {
            type: Object,
            default: null
        },
        editLink: {
            type: String,
			default: "/Admin/Tags/StandardsBook/Edit"
        },
        apiVersion: {
            type: String,
            default: ""
        }
    },
    methods: {

        updateParentSorting() {
            this.data.IsParentSortingUpdated = true;
            this.data.IsChanged = true;
        },

        deleteTagDialog: function(index) {
            dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данный тег?')
                .then(ok => {
                    this.data.Tags.splice(index, 1);
                    this.data.IsChanged = true;
                })
                .catch(cancel => { return });			
        },

        changeTag: function(value) {
            this.data.IsChanged = value;
        }
        
    },
    components: {
        TagList
    }
}
</script>
